<template>
  <div>
    <div>
      <div class="smart-main-search-container flex flex-wrap">
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.userName" placeholder="请输入用户名"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.userNo" placeholder="请输入用户编号"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.tel" placeholder="请输入用户电话"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.meterNo" placeholder="请输入电表号"></el-input>
        </div>
        <div class="w-180 mr-10">
          <el-input v-model="searchParams.conNo" placeholder="请输入集中器号"></el-input>
        </div>

        <div class="w-180 mr-10">
          <dropdown placeholder="请选择充值类型" v-model="searchParams.payType"
                    :data-list="globalData.paytype"></dropdown>
        </div>

        <div class="w-180 mr-10">
          <date-picker v-model="searchParams.startDate" value-format="yyyy-MM-dd" placeholder="请选择开始时间"></date-picker>
        </div>
        <div class="w-180 mr-10">
          <date-picker v-model="searchParams.endDate" value-format="yyyy-MM-dd" placeholder="请选择结束时间"></date-picker>
        </div>
        <div class="flex-1"></div>
        <div class="flex">
          <load-button @on-click="search"></load-button>
        </div>
        <div class="flex">
          <el-button type="primary" @click="exportE" plain>导出数据</el-button>
        </div>

      </div>
    </div>
    <div class="content mt-20">
      <smart-table :table-label="labels" :table-data="searchData.list" :table-opt="opt"></smart-table>
    </div>

    <div class="flex flex-right mt-20">
      <pagination :page="searchParams.page" :pages="searchData" @on-search="toPage"></pagination>
    </div>
  </div>
</template>
<script>
  import LoadButton from "../../components/LoadButton";
  import Pagination from "../../components/Pagination";
  import SmartTable from "../../components/SmartTable";
  import FormDialog from "../../components/FormDialog";
  import UploadImg from "../../components/UploadImg";
  import Dropdown from "../../components/Dropdown";
  import DatePicker from "../../components/DatePicker";
  export default{
    components: {
      DatePicker,
      Dropdown,
      UploadImg,
      FormDialog,
      SmartTable,
      Pagination,
      LoadButton
    },
    data(){
      return {
        searchParams: {
          page: 1
        },
        searchData: {},
        opt: [
          {label: '撤销充值', fn: this.cancelRecharge}
        ],
        labels: [
          {prop: 'createAt', label: '充值时间'},

          {prop: 'userName', label: '用户'},

          {prop: 'operName', label: '操作人'},
          {prop: 'payType', label: '支付类型', map: this.globalData.paytype},
          {prop: 'payAmount', label: '充值金额/元'},
          // {prop: 'userTel', label: '用户电话'},
          // {prop: 'conNo', label: '中继器号'},
        ],
      }
    },
    mounted(){
      this.getList()
    },
    methods: {
      search(stop){
        this.searchParams.page = 1
        this.getList(stop)
      },
      toPage(page){
        this.searchParams.page = page
        this.getList()
      },
      getList(callback){
        if(this.$store.state.LoginUser.gardenId){
          this.searchParams.gardenID = this.$store.state.LoginUser.gardenId
        }
        this.$http$({method: 'get', url: "/smartMeter/paymentLog", data: this.searchParams, load: 1}, (data) => {
          callback ? callback() : ''
          this.searchData = data
        })
      },
        exportE(){
            let url =  this.globalData.host+ "/smartMeter/export/paymentLog?accessToken="+this.$store.state.LoginUser.accessToken||"";
            // var isFirst = true;
            for (var i in this.searchParams){
                url += "&";
                url+= encodeURIComponent(i) +"=" +encodeURIComponent(this.searchParams[i]);
            }
          this.$http$({method: 'get', url: url}, () => {
            this.$router.push('/admin/downLoadTask')

          })

        },
      cancelRecharge(obj){
        this.$fnConfirm('确认撤销该充值？', () => {
          this.$http$({method: 'get', url: "/smartMeter/paymentLog/delete/" + obj.id}, (data) => {
            this.getList()
            this.$success('撤销成功！')
          })
        })

      },
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/admin/Recharge.vue